const config = {
  businessName: false,
  foreignCountry: false,
  firstName: false,
  surName: false,
  firstNamePhonetic: false,
  lastNamePhonetic: false,
  address1: false,
  address2: false,
  postCode: false,
  city: false,
  state: false,
  mobileNumber: false,
  email: false,
  privacyPolicy: false,
  updateProfile: false,
  allowPersonalEmail: false,
  allowSalesProfileSharing: false,
};

export default config;
